var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10754_25519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4853 14.0765L28.1941 2.79077H25.8934L17.4633 12.59L10.7301 2.79077H2.96423L13.1461 17.6089L2.96423 29.4437H5.26504L14.1675 19.0954L21.2782 29.4437H29.0441L18.4847 14.0765H18.4853ZM15.334 17.7395L14.3024 16.2639L6.09406 4.52279H9.62797L16.2522 13.9983L17.2838 15.4738L25.8945 27.7905H22.3606L15.334 17.7401V17.7395Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10754_25519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0799,
    height: 26.6667,
    fill: "white",
    transform: "translate(2.9613 2.79077)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f309f346d6f6447de80330ac74da416c.svg";
export { ForwardRef as ReactComponent };